module.exports = __webpack_public_path__ + "static/media/USSF-90-Min-Display-Medium.93aa8538.woff2";